import React from 'react';
import { forNamespace } from 'app/common/lib/util/i18n';
import { AddCover, SelectCover } from 'app/src/components/CardCoverChooser';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';

const PopOver = require('app/scripts/views/lib/pop-over');
const format = forNamespace('view title');

export const toggleCardCoverChooserPopover = ({
  elem,
  cardId,
  hasPotentialCovers,
}: {
  elem: Element;
  cardId: string;
  hasPotentialCovers: boolean;
}) => {
  const addCover = (options: { usePop: boolean }) => (
    <ComponentWrapper key="add-cover">
      <AddCover
        cardId={cardId}
        navigateToSelectCover={() =>
          options.usePop
            ? PopOver.popView()
            : // eslint-disable-next-line no-use-before-define
              PopOver.show({ reactElement: selectCover })
        }
      />
    </ComponentWrapper>
  );

  const navigateToAddCover = () => {
    PopOver.pushView({
      reactElement: addCover({ usePop: true }),
      displayType: 'mod-card-cover-chooser',
    });
  };

  const selectCover = (
    <ComponentWrapper key="select-cover">
      <SelectCover
        {...{
          cardId,
          navigateToAddCover,
        }}
      />
    </ComponentWrapper>
  );

  PopOver.toggle({
    elem,
    getViewTitle: () => format('cover'),
    reactElement: hasPotentialCovers
      ? selectCover
      : addCover({ usePop: false }),
    displayType: hasPotentialCovers ? '' : 'mod-card-cover-chooser',
  });
};
